import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'gf-merge',
  template: require('./merge.component.html')
})
export class MergeComponent implements OnInit {
  @Input() merge: any;
  @Input() loading: boolean;
  @Input() merging: boolean;
  @Input() showMergePanel: boolean | undefined;

  @Output() onMerge: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRefresh: EventEmitter<any> = new EventEmitter<any>();

  showInstructions: boolean = false;

  init() {
    this.showMergePanel = _.get(this, 'showMergePanel', true);
  }

  ngOnInit() {
    this.init();
  }

  ngOnChange() {
    this.init();
  }

  doMerge() {
    this.onMerge.emit();
  }

  doRefresh() {
    this.onRefresh.emit();
  }

  toggleInstructions() {
    this.showInstructions = !this.showInstructions;
  }
}
